module.exports = __webpack_public_path__ + "img/ikotun_logo_2.d3b11153.png";